export default [
  {
    path: '/wallet',
    name: 'wallet',
    component: () => import('@/views/Asset/wallet'),
    meta: { title: '资产' }
  },
  {
    path: '/walletBill',
    name: 'walletBill',
    component: () => import('@/views/Asset/walletBill'),
    meta: { title: '资产账单' }
  },
  {
    path: '/walletCurrencyDetails',
    name: 'walletCurrencyDetails',
    component: () => import('@/views/Asset/walletCurrencyDetails'),
    meta: { title: '币种账单' }
  },
  {
    path: '/walletTransfer',
    name: 'walletTransfer',
    component: () => import('@/views/Asset/walletTransfer'),
    meta: { title: '资产划转', keepAlive: true }
  },
  {
    path: '/walletSelect',
    name: 'walletSelect',
    component: () => import('@/views/Asset/walletSelect'),
    meta: { title: '币种账户选择' }
  },
  {
    path: '/walletTransferInfo',
    name: 'walletTransferInfo',
    component: () => import('@/views/Asset/walletTransferInfo'),
    meta: { title: '划转详情' }
  },
]


// WEBPACK FOOTER //
// ./src/router/config/walletRouter.js